import devConfig from './env.development';

const CONFIG = {
  USER_SERVICE_URL: 'https://fams.fitogram.pro',
  EVENT_SERVICE_URL: 'https://event-service.fitogram.pro',
  PROVIDER_SERVICE_URL: 'https://provider-service.fitogram.pro',
  CORE_SERVICE_URL: 'https://api.fitogram.pro',
  CLOUDINARY_URL: 'https://res.cloudinary.com/coursika/image/upload/',
  ONE_TRUST_URL: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
  ONE_TRUST_KEY: 'aab5fe6f-eb39-4285-af39-100487daba25',
  GOOGLE_API_KEY: 'AIzaSyCvQZt74Z31yiYbAFyXGP23AtmWq4oyAcM',
  PRO_URL: 'https://app.fitogram.pro',
  BOOKING_TOOL_URL: 'https://widget.fitogram.pro',
  SEGMENT_KEY: 'KtHBRfef8bHR4I4UeVLpj4G6AnDiKdUF',
  HOTJAR_SITE_ID: '2362208',
  HOTJAR_SITE_VERSION: '6',
  IMPORT_SERVICE_URL: 'https://import-service.fitogram.pro',
  TINY_EDITOR_KEY: 'wg0j0y7hby7s1bxvgqa87hkdr4nl2gy3gdcyl45b465qfnfc',
  ZOOM_SERVICE_URL: 'https://zis.fitogram.pro',
  UNIVERSAL_ANALYTICS_ID: 'UA-220586179-1',
  OPTIMIZE_CONTAINER_ID: 'OPT-5TPM3QK',
  GOOGLE_TAG_MANAGER_ID: 'GTM-P6XSJ9V',
  GA4_DATA_STREAM_ID: 'G-T3R6C3HG00',
  NOTIFICATION_SERVICE_URL: 'https://fns.fitogram.pro',
  USC_PROXY_SERVICE_URL: 'https://usc-proxy-service.fitogram.pro',
  ADAPTER_SVC_PARTNER_PORTAL: 'https://adapters.urbansportsclub.io/portal',
  VIDEO_INTEGRATION_SERVICE_URL: 'https://video-integration-service.fitogram.pro',
};

interface NeoConfig {
  IS_PRODUCTION: boolean;
  USER_SERVICE_URL: string;
  ADAPTER_SVC_PARTNER_PORTAL: string;
  EVENT_SERVICE_URL: string;
  CORE_SERVICE_URL: string;
  CLOUDINARY_URL: string;
  ONE_TRUST_URL: string;
  ONE_TRUST_KEY: string;
  GOOGLE_API_KEY: string;
  ENVIRONMENT: string;
  PROVIDER_SERVICE_URL: string;
  PRO_URL: string;
  SEGMENT_KEY: string;
  HOTJAR_SITE_ID: string;
  HOTJAR_SITE_VERSION: string;
  IMPORT_SERVICE_URL: string;
  TINY_EDITOR_KEY: string;
  ZOOM_SERVICE_URL: string;
  UNIVERSAL_ANALYTICS_ID: string;
  OPTIMIZE_CONTAINER_ID: string;
  GOOGLE_TAG_MANAGER_ID: string;
  GA4_DATA_STREAM_ID: string;
  NOTIFICATION_SERVICE_URL: string;
  BOOKING_TOOL_URL: string;
  USC_PROXY_SERVICE_URL: string;
  VIDEO_INTEGRATION_SERVICE_URL: string;
}

const getEnv = (config: any): NeoConfig => {
  if (process.env.NODE_ENV === 'production') {
    return { ...config, IS_PRODUCTION: true, ENVIRONMENT: process.env.NODE_ENV };
  }

  const parsedConfig = { ...config };
  Object.keys(devConfig).forEach((envVar) => {
    parsedConfig[envVar] = (devConfig as any)[envVar].replace(
      '{env-name}',
      process.env.REACT_APP_FITOVERSE_ENV as string,
    );
  });
  return { ...config, IS_PRODUCTION: false, ENVIRONMENT: process.env.NODE_ENV, ...parsedConfig };
};

export default getEnv(CONFIG);
